import React from "react"

const IconSparcaAdd = (props) => {
    const { width, height, fill, className, style } = props
    return (
        <svg
            id="icon-sparca-add"
            className={className}
            viewBox="0 0 32 32"
            width={width}
            height={height}
            fill={fill}
            style={style}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path d="M30.25,15.15H16.85V1.75a.85.85,0,0,0-1.7,0v13.4H1.75a.85.85,0,0,0,0,1.7h13.4v13.4a.85.85,0,0,0,1.7,0V16.85h13.4a.85.85,0,1,0,0-1.7Z" />
        </svg>
    )
}

export default IconSparcaAdd
